import React from "react";
import { Route, Routes } from "react-router-dom";
import { OrderDetails } from "./details/OrderDetails";
import { OrdersList } from "./list/OrdersList";

const OrdersModule = () => {
  return (
    <Routes>
      <Route index element={<OrdersList />} />
      <Route path="details/:orderId" element={<OrderDetails />} />
    </Routes>
  );
};

export default OrdersModule;
